import {
  SERVICE_READ,
  ASSET_READ,
  LOCATION_READ,
  SPARE_PART_READ,
  TOOL_READ,
  METER_READ,
  SERVICE_REQUEST_READ,
  PROCUREMENT_REQUEST_READ,
  ASSET_TRANSFER,
  REPORT_VIEW,
  DOCUMENT_VAULT_READ,
} from '../../constants/permissions';

const SidebarData = (t) => [
  {
    id: "pages",
    label: t("shared.pages", "Pages"),
    isMainMenu: true,
  },
  {
    id: "work_orders",
    label: t("shared.work_orders", "Work Orders"),
    icon: "bx bx-food-menu nav-icon",
    url: "/reactive",
    permission: SERVICE_READ,
  },
  {
    id: "service_requests",
    label: t("shared.service_requests", "Service Requests"),
    icon: "bx bx-message-square-detail nav-icon",
    url: "/service-requests",
    permission: SERVICE_REQUEST_READ,
  },
  {
    id: "planning",
    label: t("shared.planning", "Planning"),
    icon: "bx bx-calendar-check nav-icon",
    url: "/planning",
    // Any-of: the module now also hosts the asset-transfer queue, so someone who can transfer
    // assets must be able to reach it even without procurement access.
    permissions: [PROCUREMENT_REQUEST_READ, ASSET_TRANSFER],
  },
  {
    id: "inventory",
    label: t("shared.inventory", "Inventory"),
    icon: "bx bx-package nav-icon",
    permission: ASSET_READ,
    subItem: [
      { id: "assets", sublabel: t("shared.assets", "Assets"), link: "/assets" },
      { id: "spare_parts", sublabel: t("shared.spare_parts", "Spare Parts"), link: "/spare-parts", permission: SPARE_PART_READ },
      { id: "tools", sublabel: t("shared.tools", "Tools"), link: "/tools", permission: TOOL_READ },
      { id: "meters", sublabel: t("shared.meters", "Meters"), link: "/meters", permission: METER_READ },
    ],
  },
  {
    id: "locations",
    label: t("shared.locations", "Locations"),
    icon: "bx bxs-map icon nav-icon",
    url: "/locations",
    permission: LOCATION_READ,
  },
  {
    id: "reporting",
    label: t("shared.reporting", "Reporting"),
    icon: "bx bxs-bar-chart-alt-2 nav-icon",
    url: "/reporting",
    permission: REPORT_VIEW,
  },
  {
    id: "settings",
    label: t("shared.settings", "Settings"),
    icon: "bx bx-cog nav-icon",
    url: "/settings",
    matchPaths: ["/settings/my-account", "/settings/organization", "/settings/categories",
      "/settings/work-order-categories", "/settings/asset-categories", "/settings/spare-part-types",
      "/settings/contract-categories", "/settings/contracts", "/settings/users",
      "/settings/vendors", "/settings/invitations", "/settings/roles",
      "/settings/escalations"],
  },
  {
    id: "compliance",
    label: t("shared.compliance", "Compliance"),
    icon: "bx bx-shield-quarter nav-icon",
    url: "/compliance/materiovigilance",
    // OR-gated: a user with either tab's read permission sees Compliance.
    permissions: ["materiovigilance:read", DOCUMENT_VAULT_READ],
    matchPaths: [
      "/compliance",
      "/compliance/materiovigilance",
      "/compliance/materiovigilance/new/descending",
      "/compliance/materiovigilance/new/ascending",
      "/compliance/certificates",
    ],
  },
  {
    id: "knowledge_hub",
    label: t("shared.knowledge_hub", "Knowledge Hub"),
    icon: "bx bx-book-open nav-icon",
    url: "/knowledge-hub/documents",
    permission: DOCUMENT_VAULT_READ,
    matchPaths: [
      "/knowledge-hub",
      "/knowledge-hub/documents",
    ],
  },
];

/**
 * Sidebar shown while the user is in Global View (no active organization).
 * Deliberately minimal: only the cross-org rollup pages plus the platform-level
 * utility menus that don't depend on org context. Org-scoped modules
 * (Dashboard, Assets, Work Orders, …) and Settings are hidden — the user must
 * pick an organization in the switcher to access them.
 */
export const GlobalSidebarData = (t) => [
  {
    id: "pages",
    label: t("shared.pages", "Pages"),
    isMainMenu: true,
  },
  {
    id: "global_dashboard",
    label: t("shared.global_view.reports_title", "Global Reports"),
    icon: "bx bxs-bar-chart-alt-2 nav-icon",
    url: "/app/global/dashboard",
  },
  {
    id: "global_assets",
    label: t("shared.global_view.assets_title", "Global Assets"),
    icon: "bx bx-package nav-icon",
    url: "/app/global/assets",
  },
];

export default SidebarData;
